<template>
    <div v-if="globalClickBlock" class="click-block"></div>
</template>

<script>
export default {
    name: 'ClickBlocker',
    computed: {
        globalClickBlock() {
            return this.$store.getters['clickBlocker'];
        },
    },
};
</script>

<style lang="less" scoped>
.click-block {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    z-index: 9999;
}
</style>
